import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { chargebacksSummaryShape } from '../../../utils/propTypes';
import { connect } from 'react-redux';
import {
    EmvioRow as Row,
    EmvioCard as Card,
    EmvioLoadingSpinner as LoadingSpinner
} from '@nexio/emvio-util-ui';
import {
    getSelectedMerchants
} from '../../MerchantSelector/merchantSelectorViewState';
import {
    getChargebacksSummary,
    getIsChargebacksSummaryLoaded,
    getIsChargebacksSummaryLoading
} from '../chargebacksEntity';
import { getChargebacksSummary as fetchChargebacksSummary } from '../chargebacksActions';
import './ChargebacksSummary.scss';
import { getWidgetSettingsEntity } from '../../WidgetSettings/widgetSettingsEntity';
import { filterMerchantsByCurrencyAsString } from '../../WidgetSettings/widgetSettingsActions';
import {
    doesPropExistAndHasItChanged,
    getCurrencyCode,
    prettifyMoney
} from '@nexio/emvio-util-app';
import { get } from 'lodash';

export class ChargebacksSummary extends Component {
    static propTypes = {
        chargebacksSummary: chargebacksSummaryShape,
        isChargebacksSummaryLoaded: PropTypes.bool,
        isChargebacksSummaryLoading: PropTypes.bool,
        onGetChargebacksSummary: PropTypes.func,
        selectedMerchants: PropTypes.array,
        settings: PropTypes.any
    };

    static defaultProps = {
        chargebacksSummary: {}
    };

    componentDidMount() {
        const merchantsForData = filterMerchantsByCurrencyAsString(this.props.selectedMerchants, this.props.settings);
        this.props.onGetChargebacksSummary(merchantsForData);
    }

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'selectedMerchants') || doesPropExistAndHasItChanged(prevProps, this.props, 'settings')) {
            const merchantsForData = filterMerchantsByCurrencyAsString(this.props.selectedMerchants, this.props.settings);

            if (merchantsForData) {
                this.props.onGetChargebacksSummary(merchantsForData);
            }
        }
    }

    renderNewChargebacksCard = () => {
        return this.renderCard('Initial', this.props.chargebacksSummary.newChargebacksCount, this.props.chargebacksSummary.newChargebacksTotal, 'new');
    };

    renderRepresentmentCard = () => {
        const name = this.props.chargebacksSummary.representmentCount !== 1 ? 'Representments' : 'Representment';

        return this.renderCard(name, this.props.chargebacksSummary.representmentsCount, this.props.chargebacksSummary.representmentsTotal, 'representments');
    };

    renderWonCard = () => {
        return this.renderCard('Won', this.props.chargebacksSummary.wonChargebacksCount, this.props.chargebacksSummary.wonChargebacksTotal, 'won');
    };

    renderCard = (name, count = 0, total = 0, className) => {
        const classNames = `name ${className}`;
        const currencyId = get(this.props, 'settings.currencyId', '840');
        const currencyCode = getCurrencyCode(currencyId);

        return (
            <Card className="summary-card">
                {this.props.isChargebacksSummaryLoading || !this.props.isChargebacksSummaryLoaded ?
                    <LoadingSpinner isRelative />
                    : <div className="item">
                        <div className={classNames}>{count}&nbsp;{name}</div>
                        <div className="total">{prettifyMoney(Math.abs(total), currencyCode)} Total</div>
                        <div className="subtext">In the last 14 days</div>
                    </div>}
            </Card>
        );
    };

    render() {
        return (
            <Row className="emvio-chargeback-summary">
                {this.renderNewChargebacksCard()}
                {this.renderRepresentmentCard()}
                {this.renderWonCard()}
            </Row>
        );
    }
}

export function mapStateToProps(state) {
    return {
        chargebacksSummary: getChargebacksSummary(state),
        isChargebacksSummaryLoaded: getIsChargebacksSummaryLoaded(state),
        isChargebacksSummaryLoading: getIsChargebacksSummaryLoading(state),
        selectedMerchants: getSelectedMerchants(state),
        settings: getWidgetSettingsEntity(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onGetChargebacksSummary: (merchantIds) => (dispatch(fetchChargebacksSummary(merchantIds)))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChargebacksSummary);
